module.exports = __webpack_public_path__ + "img/37.84e26d16.png";